interface IInstantBookingWindow {
  instant_booking_type?: string | null;
  /** "HH:mm" local time. */
  instant_booking_from?: string | null;
  instant_booking_to?: string | null;
}

export default function instantBookingModel(
  singleListingData: IInstantBookingWindow | null | undefined,
) {
  if (singleListingData?.instant_booking_type === "ALWAYS") {
    return true;
  } else if (singleListingData?.instant_booking_type === "CUSTOM") {
    // A CUSTOM window without both times can't be checked; fall back to request booking.
    if (
      !singleListingData.instant_booking_from ||
      !singleListingData.instant_booking_to
    ) {
      return false;
    }
    const calendar = new Date();
    const startDate = new Date();
    const [hourString, minute] =
      singleListingData.instant_booking_from.split(":");
    startDate.setHours(Number(hourString), Number(minute));
    const endDate = new Date();
    const [endHourString, endMinute] =
      singleListingData.instant_booking_to.split(":");
    endDate.setHours(Number(endHourString), Number(endMinute));

    return calendar > startDate && calendar < endDate;
  } else {
    return false;
  }
}
